const NumberFormatterUtils = {
  numberFormat: (value: number, digits?: number): string => {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: digits ? digits : 2,
      maximumFractionDigits: digits ? digits : 2,
    });

    return formatter.format(value);
  },
  formatNumberWithComma(value: string): string {
    const raw = value.replace(/,/g, ""); // เอา comma ออกก่อน
    const num = parseFloat(raw);
    if (isNaN(num)) return value;
    return num.toLocaleString("en-US");
  },
  formatDynamic(num: number): string {
    if (num === 0) return "0.00";

    // 2. กรณี "Trace Amount" (มากกว่า 0 แต่น้อยกว่า 0.01)
    // เงื่อนไขนี้จะทำให้ 0.0046 หรือ 0.009 กลายเป็น "< 0.01"
    if (num > 0 && num < 0.01) {
      return "< 0.01";
    }

    // กรณีเลขปกติทั่วไป โชว์ 2 ตำแหน่ง
    return NumberFormatterUtils.numberFormat(num);
  },
};

export default NumberFormatterUtils;
